import React from 'react';
import { Outlet } from 'react-router-dom';

import { ScrollToTop, useAutoScroll } from '@ft-frontend/core';

import PosaleHeader from 'components/PosaleHeader';

import PosaleStartingInfoProvider from 'contexts/starting_info/PosaleStartingInfoProvider';

const Posale = ({ persistor }) => {
  useAutoScroll(60);

  return (
    <PosaleStartingInfoProvider>
      <ScrollToTop>
        <PosaleHeader persistor={persistor} />

        <Outlet />
      </ScrollToTop>
    </PosaleStartingInfoProvider>
  );
};

export default Posale;
